/* assets/os-product.js — One Source product page
   Handles: gallery thumb swap, gallery show-all toggle, color swatch/list view toggle,
   qty stepper, tab/accordion toggles, variant picker.
   Native Shopify product form is used — this JS just drives the UI around it.

   Sold-out safety: a 3rd-party jQuery app strips the [disabled] attribute off the
   add-to-cart button shortly after a variant change, so we do NOT rely on it alone.
   We also (a) set inline pointer-events:none on the button when unavailable and
   (b) guard the form submit so an unavailable variant can never be added. */
(function(){
  'use strict';

  // ---------- QTY STEPPERS ----------
  document.addEventListener('click', function(e){
    var btn = e.target.closest('[data-os-qty]');
    if(!btn) return;
    var wrap = btn.closest('.os-qty');
    if(!wrap) return;
    var input = wrap.querySelector('input[type=number]');
    if(!input) return;
    var d = parseInt(btn.getAttribute('data-os-qty'),10) || 0;
    var min = parseInt(input.min,10) || 1;
    input.value = Math.max(min, (parseInt(input.value,10) || min) + d);
    input.dispatchEvent(new Event('change', {bubbles:true}));
  });

  // ---------- GALLERY: thumb click swaps main image ----------
  document.addEventListener('click', function(e){
    var thumb = e.target.closest('.os-gal-thumb[data-os-media]');
    if(!thumb) return;
    var gal = thumb.closest('.os-gal');
    if(!gal) return;
    var main = gal.querySelector('.os-gal-main img');
    var src = thumb.getAttribute('data-os-media');
    var srcset = thumb.getAttribute('data-os-media-srcset') || '';
    if(main && src){
      main.src = src;
      if(srcset) main.srcset = srcset;
    }
    gal.querySelectorAll('.os-gal-thumb.on').forEach(function(t){ t.classList.remove('on'); });
    thumb.classList.add('on');
  });

  // ---------- GALLERY: show all / show fewer toggle ----------
  document.addEventListener('click', function(e){
    var t = e.target.closest('[data-os-gal-toggle]');
    if(!t) return;
    var gal = t.closest('.os-gal');
    var wrap = gal ? gal.querySelector('[data-os-thumbs]') : null;
    if(!wrap) return;
    var expanded = wrap.classList.toggle('expanded');
    t.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    t.textContent = expanded ? 'Show fewer' : ('Show all ' + wrap.querySelectorAll('.os-gal-thumb').length + ' photos');
  });

  // ---------- COLORS: swatch / list (dropdown) view toggle ----------
  document.addEventListener('click', function(e){
    var b = e.target.closest('[data-os-color-view-btn]');
    if(!b) return;
    var row = b.closest('[data-os-color-row]');
    if(!row) return;
    row.setAttribute('data-os-color-view', b.getAttribute('data-os-color-view-btn'));
    row.querySelectorAll('[data-os-color-view-btn]').forEach(function(x){ x.classList.toggle('on', x === b); });
  });

  // ---------- TABS ----------
  document.addEventListener('click', function(e){
    var btn = e.target.closest('.os-tabs button[data-os-tab]');
    if(!btn) return;
    var info = btn.closest('.os-info');
    if(!info) return;
    var id = btn.getAttribute('data-os-tab');
    info.querySelectorAll('.os-tabs button').forEach(function(b){ b.classList.toggle('on', b === btn); });
    info.querySelectorAll('.os-tab-panel').forEach(function(p){
      p.classList.toggle('on', p.getAttribute('data-os-panel') === id);
    });
  });

  // ---------- ACCORDION ----------
  document.addEventListener('click', function(e){
    var title = e.target.closest('.os-tab-panel-title');
    if(!title) return;
    var info = title.closest('.os-info');
    if(!info || info.getAttribute('data-info') !== 'accordion') return;
    title.parentElement.classList.toggle('open');
  });

  // ---------- VARIANT PICKER (server-resolved; supports >250 variants) ----------
  document.querySelectorAll('.os-buy[data-url]').forEach(function(buy){
    var form = buy.querySelector('form[action*="/cart/add"]');
    var moneyFmt = buy.getAttribute('data-money-format') || '${{amount}}';
    var productUrl = buy.getAttribute('data-url');
    var sectionId = buy.getAttribute('data-section-id');
    var selected = {};
    var current = null;
    var pending = null;

    buy.querySelectorAll('[data-option-index][data-option-value].on').forEach(function(el){
      selected[el.getAttribute('data-option-index')] = el.getAttribute('data-option-value');
    });
    buy.querySelectorAll('select[data-option-index]').forEach(function(sel){
      selected[sel.getAttribute('data-option-index')] = sel.value;
    });
    var seed = buy.querySelector('[data-os-selected-variant]');
    if(seed){ try { current = JSON.parse(seed.textContent); } catch(e){} }

    // Visually lock the ATC button when the variant is unavailable. Uses inline
    // styles (which the 3rd-party app does not touch) plus the native disabled flag.
    function lockAtc(atc, available){
      if(!atc) return;
      atc.disabled = !available;
      atc.style.pointerEvents = available ? '' : 'none';
      atc.style.opacity = available ? '' : '0.55';
    }

    // Initial state: if the page loaded on a sold-out variant, lock it now.
    (function(){
      var atc0 = form && form.querySelector('.os-atc');
      if(atc0 && current && current.available === false) lockAtc(atc0, false);
    })();

    function money(cents){
      var n = (cents/100).toFixed(2);
      return moneyFmt.replace(/\{\{\s*amount\s*\}\}/g, n);
    }

    function syncControls(i){
      var val = selected[i];
      buy.querySelectorAll('.os-swatch[data-option-index="'+i+'"], .os-chip[data-option-index="'+i+'"]').forEach(function(sw){
        sw.classList.toggle('on', sw.getAttribute('data-option-value') === val);
      });
      var sel = buy.querySelector('select[data-option-index="'+i+'"]');
      if(sel && sel.value !== val) sel.value = val;
    }

    function optionValueIds(){
      var byIndex = {};
      buy.querySelectorAll('select[data-option-index]').forEach(function(sel){
        var opt = sel.options[sel.selectedIndex];
        var id = opt && opt.getAttribute('data-option-value-id');
        if(id) byIndex[sel.getAttribute('data-option-index')] = id;
      });
      buy.querySelectorAll('.os-swatch.on[data-option-value-id], .os-chip.on[data-option-value-id]').forEach(function(el){
        byIndex[el.getAttribute('data-option-index')] = el.getAttribute('data-option-value-id');
      });
      var out = [];
      for(var k in byIndex){ if(byIndex.hasOwnProperty(k)) out.push(byIndex[k]); }
      return out;
    }

    function applyVariant(v){
      current = v;
      var idInput = form && form.querySelector('input[name="id"]');
      if(idInput) idInput.value = v ? v.id : '';

      var atc = form && form.querySelector('.os-atc');
      var atcLbl = atc && atc.querySelector('[data-os-atc-label]');

      if(!v){
        lockAtc(atc, false);
        if(atcLbl) atcLbl.textContent = 'Unavailable';
        return;
      }

      var priceEl = buy.querySelector('[data-os-price]');
      if(priceEl) priceEl.textContent = money(v.price);

      var compareEl = buy.querySelector('[data-os-compare]');
      if(compareEl){
        if(v.compare_at_price && v.compare_at_price > v.price){
          compareEl.textContent = money(v.compare_at_price);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }

      var qtyInput = form && form.querySelector('input[name="quantity"]');
      var q = qtyInput ? (parseInt(qtyInput.value,10) || 1) : 1;
      var atcPriceEl = buy.querySelector('[data-os-atc-price]');
      if(atcPriceEl) atcPriceEl.textContent = money(v.price * q);

      var skuEl = buy.querySelector('[data-os-sku]');
      if(skuEl && v.sku) skuEl.textContent = 'SKU · ' + v.sku;

      var stockEl = buy.querySelector('[data-os-stock]');
      if(stockEl){
        stockEl.textContent = v.available ? 'In Stock' : 'Sold Out';
        stockEl.classList.toggle('os-out', !v.available);
      }

      lockAtc(atc, !!v.available);
      if(atc && atcLbl) atcLbl.textContent = v.available ? (atc.getAttribute('data-label') || 'Add to Cart') : 'Sold Out';

      Object.keys(selected).forEach(function(i){
        var ol = buy.querySelector('[data-os-option-label="'+i+'"]');
        if(ol) ol.textContent = selected[i];
      });

      var mediaId = v.featured_media ? v.featured_media.id : null;
      if(mediaId){
        var thumb = document.querySelector('.os-gal-thumb[data-media-id="'+mediaId+'"]');
        if(thumb) thumb.click();
      }
    }

    function resolveAndApply(){
      var ids = optionValueIds();
      if(!ids.length) return;
      var url = productUrl + '?section_id=' + encodeURIComponent(sectionId) + '&option_values=' + ids.join(',');
      if(pending) pending.abort();
      pending = new AbortController();
      fetch(url, {signal: pending.signal})
        .then(function(r){ return r.text(); })
        .then(function(txt){
          pending = null;
          var doc = new DOMParser().parseFromString(txt, 'text/html');
          var s = doc.querySelector('[data-os-selected-variant]');
          var v = null;
          if(s){ try { v = JSON.parse(s.textContent); } catch(e){} }
          if(v && window.history && window.history.replaceState){
            window.history.replaceState({}, '', productUrl + '?variant=' + v.id);
          }
          applyVariant(v);
        })
        .catch(function(err){ if(err.name !== 'AbortError') console.error(err); });
    }

    buy.addEventListener('click', function(e){
      var el = e.target.closest('.os-swatch[data-option-index], .os-chip[data-option-index]');
      if(!el) return;
      var i = el.getAttribute('data-option-index');
      selected[i] = el.getAttribute('data-option-value');
      syncControls(i);
      resolveAndApply();
    });

    buy.querySelectorAll('select[data-option-index]').forEach(function(sel){
      sel.addEventListener('change', function(){
        var i = sel.getAttribute('data-option-index');
        selected[i] = sel.value;
        syncControls(i);
        resolveAndApply();
      });
    });

    if(form){
      // Hard guard: never allow an unavailable / unresolved variant to be added,
      // even if the disabled attribute has been stripped off the button.
      form.addEventListener('submit', function(e){
        if(!current || current.available === false){
          e.preventDefault();
          e.stopPropagation();
        }
      });

      var qtyInput = form.querySelector('input[name="quantity"]');
      if(qtyInput){
        qtyInput.addEventListener('change', function(){
          if(!current) return;
          var q = parseInt(qtyInput.value,10) || 1;
          var atcPriceEl = buy.querySelector('[data-os-atc-price]');
          if(atcPriceEl) atcPriceEl.textContent = money(current.price * q);
        });
      }
    }
  });
})();
